import { render, staticRenderFns } from "./shopGoods.vue?vue&type=template&id=b4171a6a&scoped=true"
import script from "./shopGoods.vue?vue&type=script&lang=js"
export * from "./shopGoods.vue?vue&type=script&lang=js"
import style0 from "./shopGoods.vue?vue&type=style&index=0&id=b4171a6a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4171a6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4171a6a')) {
      api.createRecord('b4171a6a', component.options)
    } else {
      api.reload('b4171a6a', component.options)
    }
    module.hot.accept("./shopGoods.vue?vue&type=template&id=b4171a6a&scoped=true", function () {
      api.rerender('b4171a6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/condom/shopGoods.vue"
export default component.exports